export default "__VITE_ASSET__f91246e6__"